import React from 'react';
import { useHistory, useParams } from 'react-router';
import { format } from 'date-fns';
import { PropsFromRedux } from '.';
// import { formatMoney } from '../../utils/common.utils';
// import RatingForm from '../RatingForm';
import { API_KEYS } from '../../interfaces/api';
import ModalWrapper from '../common/ModalWrapper';
import { TRACKING_OBJECT } from '../../interfaces/shipping.interface';
import ShipmentTimeline from './ShipmentTimeline';
import { Spinner } from '../Spinners/Spinner';

interface Props extends PropsFromRedux {}

const TrackShipment: React.FC<Props> = ({
  hideModal,
  trackShipmentState,
  resetApi,
  modal,
  trackShipment,
}) => {
  const history = useHistory();
  const { trackingCode } = useParams<{ trackingCode: string }>();

  const { loading, error, response } = trackShipmentState || {};
  const waybill = modal?.ownProps?.waybill;

  React.useEffect(() => {
    if (trackingCode && !waybill) {
      trackShipment(trackingCode);
    } else if (waybill) {
      trackShipment(waybill);
    }
    return () => {
      resetApi(API_KEYS.TRACK_SHIPMENT);
      resetApi(API_KEYS.ADD_RATING);
    };
  }, [trackingCode, waybill, trackShipment, resetApi]);

  React.useEffect(() => {
    if (error) {
      hideModal();
      if (!waybill) {
        history.push('/');
      }
    }
    return () => {
      resetApi(API_KEYS.TRACK_SHIPMENT);
    };
  }, [resetApi, waybill, error, hideModal, history]);

  if (loading) {  
    return (
      <ModalWrapper
        hideCloseButton
        hideModal={hideModal}
        redirectOnClose={!waybill ? undefined : '/'}
      >
        <Spinner color="#CCC" />
      </ModalWrapper>
    );
  }

  // console.log('waybill',waybill);

  if (response?.Object) {
    const trackingObject: TRACKING_OBJECT = response?.Object;
    const trackingVisitingObj = response?.Object.ManifestVisitMonitorings;
    const transactionDate = trackingObject.MobileShipmentTrackings?.length
      ? trackingObject.MobileShipmentTrackings[
          trackingObject.MobileShipmentTrackings.length - 1
        ]?.DateTime
      : null;
    return (
      <ModalWrapper
        hideModal={hideModal}
        redirectOnClose={waybill ? undefined : '/'}
      >
        <h4 className="mb-10 font-sans text-2xl font-black text-center">
          Track Shipment
        </h4>
        <div className="w-full">
          <h4 className="mb-3 font-sans text-lg font-extrabold text-green-500">
            Delivery Address
          </h4>
          <div className="w-full">
            <div className="w-full pt-3 pb-10 mb-5 bg-white rounded-lg shadow-lg px-9">
              <p className="mb-2 text-xs">From</p>
              <p className="text-sm font-medium">{trackingObject?.Origin}</p>
            </div>
            <div className="w-full pt-3 pb-10 mb-5 bg-white rounded-lg shadow-lg px-9">
              <p className="mb-2 text-xs">Shipment Destination</p>
              <p className="text-sm font-medium">
                {trackingObject?.Destination}
              </p>
            </div>
          </div>
        </div>

        <div className="w-full py-4">
          <h4 className="mb-3 font-sans text-lg font-extrabold text-green-500">
              Tracking History
            </h4>
        </div>

        <div className="flex flex-wrap w-full py-3">
          <div className="w-1/2 lg:w-1/3">
            <p className="mb-1 text-xs font-medium">Waybill number</p>
            <p className="text-lg font-medium">{trackingCode || waybill}</p>
          </div>
          <div className="w-1/2 lg:w-1/3">
            <p className="mb-1 text-xs font-medium">Date</p>
            <p className="text-lg font-medium">
              {transactionDate &&
                format(new Date(transactionDate), 'dd/MM/yyyy')}
            </p>
          </div>
          {/* <div className="w-1/2 lg:w-1/3">
            <p className="mb-1 text-xs font-medium">Amount paid</p>
            <p className="text-lg font-medium">
              {formatMoney(
                shipmentDetail?.CalculatedTotal,
                shipmentDetail?.CurrencyCode || 'NGN'
              ).replace(
                shipmentDetail?.CurrencyCode || 'NGN',
                shipmentDetail?.CurrencySymbol
              )}
            </p>
          </div> */}
        </div>

        <div className="w-full my-6">
          {trackingObject?.MobileShipmentTrackings?.map((timeline) => (
            <ShipmentTimeline key={timeline.DateTime} timeline={timeline} />
          ))}
        </div>

        {/*  <div className="my-10">
          <RatingForm />
        </div> */}


{ trackingVisitingObj !== null && (
          <div className="w-full">
          <h4 className="mb-3 font-sans text-lg font-extrabold text-green-500">
            Visiting History
          </h4>

          <div className="grid grid-cols-4 gap-4 py-4 font-semibold border-b">
              <div className="">
                  <h3>Receiver Name</h3>
                </div>
                <div className="mr-1">
                  <h3>PhoneNumber</h3>
                </div>
                <div className="">
                  <h3>Address</h3>
                </div>
                <div className="">
                  <h3>Status</h3>
                </div>
          </div>
          <div className="grid grid-cols-4 gap-4 py-4">
          <div className="py-4">
              {trackingVisitingObj.map((visitVal : any) => (
                    <h3 key="{visitVal}" className="py-4">{visitVal?.ReceiverName}</h3>
              ))}
            
            </div>
            <div className="py-4">
              {trackingVisitingObj.map((visitVal : any) => (
                    <h3 key="{visitVal}" className="py-4">{visitVal?.ReceiverPhoneNumber}</h3>
              ))}
            </div>  

            <div className="py-4 text-sm">
            {trackingVisitingObj.map((visitVal : any) => (
                    <h3 key="{visitVal}"className="py-4" >{visitVal?.Address}</h3>
              ))}
            </div>
              
            <div className="py-4 text-sm">
            {trackingVisitingObj.map((visitVal : any) => (
                    <h3 key="{visitVal}" className="py-4">{visitVal?.Status}</h3>
              ))}
            </div>

          </div>  
          </div>
)}
      </ModalWrapper>
    );
  }
  return null;
};

export default TrackShipment;
